import React from 'react';
import { Link } from 'react-router-dom';

const services = [
  {
    icon:'🩺', title:'Routine Dental Check-up',
    desc:'Regular dental check-ups help detect problems early, keeping your teeth and gums healthy for a lifetime of confident smiles.',
    includes:['Comprehensive oral examination','Cavity detection','Gum health assessment','Personalised oral hygiene advice'],
    from:'On consultation',
  },
  {
    icon:'✨', title:'Scaling & Polishing',
    desc:'Professional cleaning removes plaque and tartar build-up that regular brushing can\'t reach, leaving your teeth smooth and bright.',
    includes:['Ultrasonic scaling','Stain removal','Teeth polishing','Fluoride application'],
    from:'On consultation',
  },
  {
    icon:'🦷', title:'Root Canal Treatment',
    desc:'Save an infected or badly damaged tooth with a painless root canal procedure that removes infection and restores full function.',
    includes:['Digital X-ray & diagnosis','Pulp removal & cleaning','Canal shaping & filling','Crown recommendation'],
    from:'On consultation',
  },
  {
    icon:'👑', title:'Dental Bridges & Crown',
    desc:'Restore missing or damaged teeth with custom-crafted bridges and crowns that blend seamlessly with your natural smile.',
    includes:['Tooth preparation','Impression & shade matching','Custom crown fabrication','Precise fitting & bonding'],
    from:'On consultation',
  },
  {
    icon:'🏆', title:'Dental Implants',
    desc:'Permanent tooth replacement with advanced implant solutions — All-on-4, All-on-6, Zygomatic Implants, and Same-Day Dental Implants.',
    includes:['All-on-4 & All-on-6 full-arch implants','Zygomatic implants for severe bone loss','Same-day dental implants','3D-guided implant planning'],
    from:'On consultation',
  },
  {
    icon:'💎', title:'Teeth Whitening',
    desc:'Professional teeth whitening treatments that safely brighten your smile by several shades in just one visit.',
    includes:['Shade assessment','Professional-grade whitening','Sensitivity management','Post-treatment care guidance'],
    from:'On consultation',
  },
  {
    icon:'🌟', title:'Cosmetic Dentistry',
    desc:'Transform your smile with comprehensive cosmetic treatments designed to enhance the appearance and confidence of your teeth.',
    includes:['Smile design consultation','Tooth reshaping & contouring','Composite bonding','Complete smile makeover planning'],
    from:'On consultation',
  },
  {
    icon:'🪞', title:'Porcelain Veneers',
    desc:'Ultra-thin porcelain shells custom-bonded to the front of your teeth to correct chips, gaps, discolouration, and uneven alignment.',
    includes:['Digital smile preview','Minimal tooth preparation','Custom veneer fabrication','Precision bonding & finishing'],
    from:'On consultation',
  },
  {
    icon:'🩹', title:'Gum Disease Treatment',
    desc:'Expert treatment for gingivitis and periodontitis to stop infection, reduce inflammation, and protect the foundation of your teeth.',
    includes:['Periodontal assessment','Deep cleaning (root planing)','Antibiotic therapy','Maintenance & follow-up plan'],
    from:'On consultation',
  },
  {
    icon:'⚡', title:'Laser Dentistry',
    desc:'Minimally invasive laser procedures for soft and hard tissue treatments — less pain, faster healing, and greater precision.',
    includes:['Laser gum contouring','Laser-assisted decay removal','Soft tissue surgery','Faster recovery protocols'],
    from:'On consultation',
  },
  {
    icon:'🤍', title:'Cleft Surgery',
    desc:'Specialised cleft lip and palate surgical care under the guidance of Dr. Sangeeta Arvind, a dedicated cleft specialist.',
    includes:['Initial consultation & assessment','Surgical planning','Cleft lip & palate repair','Post-operative follow-up care'],
    from:'On consultation',
  },
  {
    icon:'🔧', title:'TMJ Treatment',
    desc:'Relief from jaw pain, clicking, and restricted movement with expert diagnosis and treatment of temporomandibular joint disorders.',
    includes:['TMJ evaluation & diagnosis','Bite analysis','Splint / night guard therapy','Pain management & physiotherapy guidance'],
    from:'On consultation',
  },
  {
    icon:'🦴', title:'Fracture of Jaw Treatment',
    desc:'Expert maxillofacial surgical care for jaw fractures — precise reduction and fixation for optimal healing and function.',
    includes:['Emergency assessment','Digital imaging & diagnosis','Surgical fixation (plating)','Rehabilitation & follow-up'],
    from:'On consultation',
  },
  {
    icon:'🎯', title:'3D Guided Implant Surgery',
    desc:'Computer-guided implant placement using advanced 3D imaging for unmatched accuracy, safety, and predictable outcomes.',
    includes:['CBCT scan & 3D planning','Virtual implant simulation','Surgical guide fabrication','Precise flapless implant placement'],
    from:'On consultation',
  },
];

function PageHero({ title, sub }) {
  return (
    <div className="page-hero">
      <div className="page-hero-bg"/>
      <div className="container">
        <span className="section-tag">Dant Sanjeevani</span>
        <h1 className="page-hero-title">{title}</h1>
        <p className="page-hero-sub">{sub}</p>
      </div>
    </div>
  );
}

export default function Services() {
  return (
    <>
      <PageHero title={<>Our <em>Clinical Services</em></>} sub="Comprehensive dental, maxillofacial & cleft care — from routine check-ups to advanced 3D-guided implant surgery." />

      <section className="section">
        <div className="container">
          <div className="services-detail-grid">
            {services.map((s, i) => (
              <div key={i} className="svc-card reveal" style={{'--delay': `${(i % 2) * 0.1}s`}}>
                <div className="svc-card-header">
                  <div className="svc-icon-wrap"><span className="svc-icon">{s.icon}</span></div>
                  <div>
                    <h2 className="svc-title">{s.title}</h2>
                    <span className="svc-from">Starting from <strong>{s.from}</strong></span>
                  </div>
                </div>
                <p className="svc-desc">{s.desc}</p>
                <div className="svc-includes">
                  <h4>What's included</h4>
                  <ul>
                    {s.includes.map((item, j) => <li key={j}><span className="check">✓</span>{item}</li>)}
                  </ul>
                </div>
                <Link to="/contact" className="btn-primary svc-cta">Book This Treatment →</Link>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Why choose section */}
      <section className="section" style={{paddingTop:0}}>
        <div className="container">
          <div className="why-strip reveal">
            <div className="why-strip-text">
              <h2>All Treatments Include</h2>
              <p>Direct clinic contact, consultation-based guidance, and treatment discussion based on the patient&apos;s clinical need.</p>
            </div>
            <div className="why-strip-badges">
              {['Oral Surgery','Implantology','Cleft Care','Cosmetic Dentistry','Laser Dentistry','TMJ Care','Call for Appointment'].map(b => (
                <span key={b} className="badge-pill">{b}</span>
              ))}
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
